<div *ngIf="isVisible" class="page-spinner-container" >
    <div class="page-spinner tds-headline-06 ">
        <tds-spinner size="lg" variant="standard" style="margin-top: 64px;"></tds-spinner>
        <div *ngIf="message.trim() != ''" class="tds-u-p2 tds-u-mt2 spinner-message ">
            {{message}}
        </div>
        <div *ngIf="message.trim() == ''" class="tds-u-p2 tds-u-mt2 spinner-message ">
            {{getMessage()}}
        </div>
    </div>      
</div>